import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as constants from 'src/app/config/app-constants';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertWizardComponent } from '../alert-wizard/alert-wizard.component';
import { GcnDrugs, GroupCanister, UpdateGroupCanister,DrawerSelection } from '../../models/gcn-drugs';
import { AssignDrawerLocation, AtpDeiceDrawerCell, AtpDeviceSelectedDrawer } from '../../models/device-cell';
import { ImToolAtpService } from '../../services/im-tool-atp.service';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-import-wizard-gcn-atp-caps',
  templateUrl: './import-wizard-gcn-atp-caps.component.html',
  styleUrls: ['./import-wizard-gcn-atp-caps.component.scss'],
  animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class ImportWizardGcnAtpCapsComponent implements OnInit {

  @Output() hideSide = new EventEmitter<number>();
  @Output() closeWizard = new EventEmitter<boolean>();

  @Input() customerId:string;
  @Input() highCapDrawerNo:number;
  @Input() highCapSmartDrawerNo:number;
  @Input() smartDrawerNo:number;
  @Input() deviceTypeId:number;


  //#region Group Canister
  @ViewChild("TABLE1") table1: ElementRef;
  dataSourceGroupCanister = new MatTableDataSource<GroupCanister>([]);
   //#region Table colums Array
   displayedColumnsGroupCanister: string[] = [
    'checkbox',
    'topOrder',
    'name',
    'ndc',
    'strength',
    'usage',
    'daysOfPillQtyReq',
    'bottleQty',
    'maxCap',
    'hccMaxCap',
    'recCanister',
    'groupCanister',
    'recHcCanister', 
    'highCapGroupCanister',
  ];


  
//#endregion

  selectedRow:any;
  selectedGcnDrugList: GcnDrugs[] = [];

  constructor(
    private imToolAtpService: ImToolAtpService,
    private ngxLoader: NgxUiLoaderService,
    public dialog: MatDialog,
    private route: Router,
    private toastService: ToastService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    }

  ngOnInit(): void {
    this.getGroupCanisterLocationForCaps();
    this.deviceAllCellGenerate();
    this.configureDrawerByDeviceType(this.deviceTypeId);
    this.defineDrawers();
  }

  redirectToAtpCapsDrugPage(){
    this.route.navigate([ '/im-tool/atp-caps-export', this.customerId]);
  }

  //#region Group Canisnter
  saveGroupCanister() {
    this.groupCanisterModel = null;
    for (let i = 0; i < this.selectedDeviceDrawerListByNdc.length; i++) {
      for (let j = 0; j < this.selectGroupCanistherList.length; j++) {
        if (this.selectedDeviceDrawerListByNdc[i].ndc === this.selectGroupCanistherList[j].ndc) {
          this.selectGroupCanistherList[j].drawers.push({
            drawerNo: this.selectedDeviceDrawerListByNdc[i].drawerNumber,
            locations: this.selectedDeviceDrawerListByNdc[i].drawerCell,
          });
        }
      }
    }
    const GROUPCANISTER_KEY = 'Groupcanisterkey'
    this.ngxLoader.start(GROUPCANISTER_KEY);

    this.groupCanisterModel = {
      customerId: this.customerId,
      drugs: this.selectGroupCanistherList
    }

    this.imToolAtpService.finalImportForAtpCaps(this.groupCanisterModel).subscribe((result) => {
      this.selectGroupCanistherList = [];
      if (result.statusCode === 200) {
        this.toastService.openToast(result.message, constants.ToastPanelType.done, 2);
        this.ngxLoader.stop(GROUPCANISTER_KEY);
        this.dataSourceGroupCanister.data = [];
        this.selectGroupCanistherList = [];
        this.closeWizard.emit(true)
        this.redirectToAtpCapsDrugPage()
      }
      else {
        this.toastService.openToast(result.message, constants.ToastPanelType.error, 2);
        this.ngxLoader.stop(GROUPCANISTER_KEY);
      }

    }, (error: HttpErrorResponse) => {

      this.ngxLoader.stop(GROUPCANISTER_KEY);
      console.log(error);
      this.toastService.openToast(
        error.error.message ?? error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  getGroupCanisterLocationForCaps() {
    const GROUPCANISTERLOCATION_KEY = 'Groupcanisterlocationkey'
    this.ngxLoader.start(GROUPCANISTERLOCATION_KEY);
    this.imToolAtpService.getGroupCanisterForCaps(this.customerId).subscribe((response) => {
      let result = response.data
      this.dataSourceGroupCanister.data = result?.groupCanisterDrugs;
      this.assignDrawerCellList = result?.assignedDrawerLocations;
      this.selectedGcnDrugList = [];
      this.ngxLoader.stop(GROUPCANISTERLOCATION_KEY);
    }, (error: HttpErrorResponse) => {
      this.ngxLoader.stop(GROUPCANISTERLOCATION_KEY);
      console.log(error);
      this.toastService.openToast(
        error.error.message ?? error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }

  updateSelectedGroupCanisterList(row) {
    this.selectGroupCanistherList.forEach(x => {
      if (x.ndc == row.ndc) {
        x.groupCanister = row.groupCanister === -1 ? 0 : row.groupCanister,
          x.highCapGroupCanister = row.highCapGroupCanister === -1 ? 0 : row.highCapGroupCanister
      }
    })
  }
  

finalDrawers : DrawerSelection[] = [];
drawerGroup: number[][] = [];
smartDrawers: number[] = [];
configureDrawerByDeviceType(deviceTypeId: number): void {
  switch (deviceTypeId) {
    case 24:
      this.drawerGroup = [];
      this.smartDrawers = [1, 2, 3, 4 ];
      break;

    case 25:
      this.drawerGroup = [
        [2, 6],
        [3, 7]
      ];
      this.smartDrawers=[1, 2, 3, 4, 5, 6, 7, 8];
    case 26:
      this.drawerGroup = [
        [2, 6],
        [3, 7]
      ];
      this.smartDrawers = [9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8];
      break;

    case 27:
      this.drawerGroup = [
        [2, 6],
        [3, 7],
        [10, 14],
        [11, 15],
        [1, 5],
        [4, 8],
        [9, 13],
        [12,16]
      ];
      this.smartDrawers=[9, 10, 11, 12, 13, 14, 15, 16, 1, 2, 3, 4, 5, 6, 7, 8 ]
      break;

      case 28:
        this.drawerGroup = [
          [2, 6],
          [3, 7],
          [10, 14],
          [11, 15],
          [1, 5],
          [4, 8],
          [9, 13],
          [12,16]
        ];
        this.smartDrawers=[9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 1, 2, 3, 4, 5, 6, 7, 8]
        break;

        case 29:
          this.drawerGroup = [
            [2, 6],
            [3, 7],
            [10, 14],
            [11, 15],
            [1, 5],
            [4, 8],
            [9, 13],
            [12,16],
            [21,22],
            [23,24]
          ];
          this.smartDrawers=[9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 1, 2, 3, 4, 5, 6, 7, 8 ]
          break;

          case 30:
          this.drawerGroup = [
            [2, 6],
            [3, 7],
            [10, 14],
            [11, 15],
            [1, 5],
            [4, 8],
            [9, 13],
            [12, 16],
            [21, 22],
            [26, 27],
            [23, 24],
            [28, 29]
          ];
          this.smartDrawers=[9, 12, 13, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 1, 2, 3, 4, 5, 6, 7, 8  ]
          break;
  }
}

defineDrawers(){
  
  let combinDrawers: number[] = [];
  for (let i = 0; i < this.highCapDrawerNo; i++) {
    const drawerGroup = this.drawerGroup[i];
    const drawerObj: DrawerSelection = { drawerNo: drawerGroup[0],  group: drawerGroup, lebel: 'highcaplevel', type : 1 };
    this.finalDrawers.push(drawerObj);
    combinDrawers = [...combinDrawers, ...drawerGroup];
  }
  for (let i = this.highCapDrawerNo; i < this.highCapDrawerNo + this.highCapSmartDrawerNo; i++) {
    const drawerGroup = this.drawerGroup[i];
    const drawerObj: DrawerSelection = { drawerNo: drawerGroup[0],  group: drawerGroup, lebel: 'smarthighcaplevel', type : 2 };
    this.finalDrawers.push(drawerObj);
    combinDrawers = [...combinDrawers, ...drawerGroup];
  }
  
  let drawerleft = this.smartDrawers.filter(num => !combinDrawers.includes(num));

  for(let i = 0; i < this.smartDrawerNo; i++) {
    const drawerGroup = drawerleft[i];
    const drawerObj: DrawerSelection = { drawerNo: drawerGroup,  group: [drawerGroup], lebel: 'smartdrawerlevel', type : 3 };
    this.finalDrawers.push(drawerObj);
  }
  for(let i = this.smartDrawerNo; i < drawerleft.length; i++) {
    const drawerGroup = drawerleft[i];
    const drawerObj: DrawerSelection = { drawerNo: drawerGroup,  group: [drawerGroup], lebel: '', type : 4 };
    this.finalDrawers.push(drawerObj);
  }
  const finalDrawrrs = [...this.finalDrawers];
  console.log(finalDrawrrs);
}

showhideElement(ndc: string, drawerNo: number, event) {
  let selectorId = '';
  if (!this.isApplicableThisDrawer(this.deviceTypeId, drawerNo)) {
    return;
  }
  
  const drawerConfig = this.finalDrawers.find(x=> x.drawerNo == drawerNo);
  if(drawerConfig) {
    selectorId = `${ndc}-${drawerNo}`;
    const drawerText = `Drawer ${drawerConfig.group.join(' & ')}`;
    document.getElementById(`drawerlevel-${selectorId}`).innerText = drawerText;
    const eleId = `${drawerConfig.lebel}-${selectorId}`;
    let element = document.getElementById(eleId);
    if(element) {
      element.style.display = element.style.display === 'none' ? 'block' : 'none';
    }
    const drawerConfigType = drawerConfig.type;
    switch (drawerConfigType) {
      case 1:
        this.selectDrawer(drawerNo, ndc, event, true);
        break;
    
      case 2:
        this.selectDrawer(drawerNo, ndc, event, true);
        break;
    
      case 3:
        this.selectDrawer(drawerNo, ndc, event, false, true);
        break;
    
      case 4:
        this.selectDrawer(drawerNo, ndc, event, false, false);
        break;
    
      default:
        console.error(`Unknown drawerConfigType: ${drawerConfigType}`);
        break;
    }
  }
  
  if (selectorId.length > 0) {
    const elementById = document.getElementById(selectorId)
    elementById.style.display = elementById.style.display === 'none' ? 'block' : 'none';
  }
}




  showhideElementOld(ndc: string, drawerNo: number, event) {
    let selectorId = '';
    if (!this.isApplicableThisDrawer(this.deviceTypeId, drawerNo)) {
      return;
    }
    if (this.highCapDrawerNo === 1 && (drawerNo === 2 || drawerNo === 6)) {

      if (drawerNo === 2) {
        selectorId = `${ndc}-${2}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 2 & 6'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';

        this.selectDrawer(drawerNo, ndc, event, true);
      }

    }
    else if (this.highCapDrawerNo === 2 && (drawerNo === 2 || drawerNo === 6)) {

      if (drawerNo === 2) {
        selectorId = `${ndc}-${2}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 2 & 6'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }
    }
    else if (this.highCapDrawerNo === 2 && (drawerNo === 3 || drawerNo === 7)) {

      if (drawerNo === 3) {
        selectorId = `${ndc}-${3}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 3 & 7'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }

    }
    else if (this.highCapDrawerNo === 3 && (drawerNo === 2 || drawerNo === 6)) {

      if (drawerNo === 2) {
        selectorId = `${ndc}-${2}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 2 & 6'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }
    }
    else if (this.highCapDrawerNo === 3 && (drawerNo === 3 || drawerNo === 7)) {

      if (drawerNo === 3) {
        selectorId = `${ndc}-${3}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 3 & 7'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }

    }
    else if (this.highCapDrawerNo === 3 && (drawerNo === 10 || drawerNo === 14)) {

      if (drawerNo === 10) {
        selectorId = `${ndc}-${10}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 10 & 14'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }
    }
    else if (this.highCapDrawerNo === 4 && (drawerNo === 2 || drawerNo === 6)) {


      if (drawerNo === 2) {
        selectorId = `${ndc}-${2}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 2 & 6'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }
    }
    else if (this.highCapDrawerNo === 4 && (drawerNo === 3 || drawerNo === 7)) {

      if (drawerNo === 3) {
        selectorId = `${ndc}-${3}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 3 & 7'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }
    }
    else if (this.highCapDrawerNo === 4 && (drawerNo === 10 || drawerNo === 14)) {

      if (drawerNo === 10) {
        selectorId = `${ndc}-${10}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 10 & 14'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }
    }
    else if (this.highCapDrawerNo === 4 && (drawerNo === 11 || drawerNo === 15)) {

      if (drawerNo === 11) {
        selectorId = `${ndc}-${11}`
        document.getElementById(`drawerlevel-${selectorId}`).innerText = 'Drawer 11 & 15'
        let element = document.getElementById(`highcaplevel-${selectorId}`);
        element.style.display = element.style.display === 'none' ? 'block' : 'none';
        this.selectDrawer(drawerNo, ndc, event, true);
      }

    }
    else {
      selectorId = `${ndc}-${drawerNo}`
     
      if(this.lebelShowForSmartDrawer(ndc, drawerNo, event)){
        this.selectDrawer(drawerNo, ndc, event, false, true);
      }
      else{
        this.selectDrawer(drawerNo, ndc, event, false, false);
      }

    }
    if (selectorId.length > 0) {
      const elementById = document.getElementById(selectorId)
      elementById.style.display = elementById.style.display === 'none' ? 'block' : 'none';
    }
   
  }
  lebelShowForSmartDrawer(ndc: string, drawerNo: number, event):boolean{
     let selectorId = '';
     const maxCanister = drawerNo * 16;
     let limitOfSmartDrawar  = 0;

     let smartdrawer = this.atpSubDevices.find(x=>x.Id == this.deviceTypeId).SmartDrawer;
      let highcap = this.highCapDrawerNo >2?2: smartdrawer>=9?0 : this.highCapDrawerNo;
      limitOfSmartDrawar = (smartdrawer + highcap +this.smartDrawerNo-1) * 16;
   
      smartdrawer *= 16
     if(maxCanister>=smartdrawer && maxCanister <=limitOfSmartDrawar){
      selectorId = `${ndc}-${drawerNo}`
     }
     if(selectorId?.length>0){
     let element = document.getElementById(`smartdrawerlevel-${selectorId}`);
     element.style.display = element.style.display === 'none' ? 'block' : 'none';
     return true;
     }
     return false;
  }

  isApplicableThisDrawer(deviceId: number, drawerNo: number): boolean {
    const maxCanisterAmount = drawerNo * 16;
    let output = false;
    for (let i = 0; i < this.atpSubDevices.length; i++) {
      if (this.atpSubDevices[i].Id === deviceId && maxCanisterAmount <= this.atpSubDevices[i].CanisterAmount) {

        output = true;
        break;

      }
    }
    if (!output) {
      this.toastService.openToast(`Drawer ${drawerNo} is not available for sub-device ${this.atpSubDevices.find(x => x.Id === deviceId).CanisterAmount}.`, constants.ToastPanelType.error, 2);
    }
    return output;
  }

  groupCanisterRowSelect(row: any, isChecked: boolean) {
    if (isChecked) {
      let index = this.dataSourceGroupCanister.data.findIndex(
        (x) => x.ndc === row.ndc
      );
      this.selectGroupCanistherList.push({
        isChecked: true,
        topOrder: row.topOrder,
        strength: row.strength,
        ndc: row.ndc,
        groupCanister: row.groupCanister,
        highCapGroupCanister: row.highCapGroupCanister,
        usage: row.usage,
        bottleQty: row.bottleQty,
        maxCap: row.maxCap,
        hccMaxCap: row.hccMaxCap,
        recCanister : row.recCanister,
        recHcCanister : row.recHcCanister,
        daysOfPillQtyReq: row.daysOfPillQtyReq,
        drawers: []
      });
      this.dataSourceGroupCanister.data[index].isChecked = true;


    } else {
      let index = this.selectGroupCanistherList.findIndex(
        (x) => x.ndc == row.ndc
      );
      if (index >= 0) {
        this.selectGroupCanistherList.splice(index, 1);
        setTimeout(() => {
          this.dataSourceGroupCanister.data[index].isChecked = false;
        }, 20)

      }
      this.clearUncheckedRowDrawer(row.ndc);
    }
  }

  atpTableData: number[][] = [
    [13, 14, 15, 16],
    [9, 10, 11, 12],
    [5, 6, 7, 8],
    [1, 2, 3, 4]
  ];


  atpSubDevices = [
    {
      Id: 23,
      CanisterAmount: 64,
      SmartDrawer:1
    },
    {
      Id: 24,
      CanisterAmount: 128,
      SmartDrawer:5
    },
    {
      Id: 25,
      CanisterAmount: 192,
      SmartDrawer:9
    },
    {
      Id: 26,
      CanisterAmount: 256,
      SmartDrawer:9
    },
    {
      Id: 27,
      CanisterAmount: 320,
      SmartDrawer:9
    },
    {
      Id: 28,
      CanisterAmount: 400,
      SmartDrawer:9
    },
    {
      Id: 29,
      CanisterAmount: 480,
      SmartDrawer:9
    }
  ];


  deviceCell: number[][];
  deviceDrawer: AtpDeiceDrawerCell[] = [];
  devceDrawerLevel: string = ''
  selectedDeviceDrawerListByNdc: AtpDeviceSelectedDrawer[] = []
  assignDrawerCellList: AssignDrawerLocation[] =[];
  selectGroupCanistherList: GroupCanister[] = [];
  groupCanisterModel: UpdateGroupCanister;
  saveGroupDrugListModel: GroupCanister[] = [];
  cleanTheGroupCanisterData() {
    this.deviceCell = [];
    this.deviceDrawer = [];
    this.devceDrawerLevel = ''
    this.selectedDeviceDrawerListByNdc = []
    this.selectGroupCanistherList = []
  }

  openAlertWindowForGroupCanisterBackButton() {
    const dialogRef = this.dialog.open(AlertWizardComponent, {
      backdropClass: ['smDialog'],
      disableClose: true,
      data: {
        alertIcon: "/assets/img/icons/ico.16.alert.svg",
        title: "Warning!",
        bodyMessage: "Navigating back will result in the loss of any changes made on this page.",
        cancelBtnText: "Cancel",
        confirmBtnText: "Ok",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.cleanTheGroupCanisterData();
        this.hideSide.emit(3);
      } else {
        console.log("Cancel=", result);
      }
    });
  }

  IsDrawerSelect(drawer: number, ndc: string): boolean {
    for (let i = 0; i < this.selectedDeviceDrawerListByNdc.length; i++) {
      if (this.selectedDeviceDrawerListByNdc[i].drawerNumber == drawer && this.selectedDeviceDrawerListByNdc[i].ndc == ndc) {
        return false;
      }
    }
    return true;
  }

  clearUncheckedRowDrawer(ndc: string) {

    this.cleartheUncheckedRowDrawerColor(ndc);

    let index = this.selectedDeviceDrawerListByNdc.findIndex(x => x.ndc === ndc);
    if (index >= 0) {
      this.selectedDeviceDrawerListByNdc.splice(index, this.selectedDeviceDrawerListByNdc.filter(x => x.ndc === ndc).length);
    }
  }
  cleartheUncheckedRowDrawerColor(ndc) {
    for (let i = 0; i < this.selectedDeviceDrawerListByNdc.length; i++) {
      if (this.selectedDeviceDrawerListByNdc[i].ndc === ndc) {
        let element = document.getElementById(`drawer-${ndc}-${this.selectedDeviceDrawerListByNdc[i].drawerNumber}`)
        this.hidetheuncheckedRowDrawer(ndc, this.selectedDeviceDrawerListByNdc[i].drawerNumber);
        element.classList.remove('selected-drawer')
        element.classList.remove('smart-drawer');
        for (let j = 0; j < this.selectedDeviceDrawerListByNdc[i].drawerCell.length; j++) {
          let element = document.getElementById(`drawercell-${ndc}-${this.selectedDeviceDrawerListByNdc[i].drawerNumber}-${this.selectedDeviceDrawerListByNdc[i].drawerCell[j]}`)
          element.classList.remove('selected-cell')
        }
      }
    }

  }

  hidetheuncheckedRowDrawer(ndc, drawerNo) {
    let selectorId = `${ndc}-${drawerNo}`
    let element = document.getElementById(`highcaplevel-${selectorId}`);
    if (element)
      element.style.display = 'none';

    document.getElementById(`${selectorId}`).style.display = 'none';
  }




  selectDrawer(drawer: number, ndc: string, event, isHighCapCanister: boolean = false, isSmart = false): boolean {
    let element = event.target;
    if (this.IsDrawerSelect(drawer, ndc)) {
      this.selectedDeviceDrawerListByNdc.push({
        ndc: ndc,
        drawerNumber: drawer,
        isHighCapCanister: isHighCapCanister,
        drawerCell: []
      })
      element.classList.add('selected-drawer')
      if(isSmart)
        element.classList.add('smart-drawer');
    }
    else {
      let index = this.selectedDeviceDrawerListByNdc.findIndex(x => x.drawerNumber === drawer && x.ndc === ndc)

      this.removeTheSelectedCellWithDrawer(index);
      this.selectedDeviceDrawerListByNdc.splice(index, 1);

      element.classList.remove('selected-drawer')
      element.classList.remove('smart-drawer');

      let [groupCanister, highCapGroupCanister] = this.selectedListLengthBasedOnNdc(ndc);
      this.updateDataSet({ndc, groupCanister, highCapGroupCanister})
    }
    return true;
  }

  removeTheSelectedCellWithDrawer(index:number){
    this.selectedDeviceDrawerListByNdc[index].drawerCell.forEach(cell => {
      let element = document.getElementById(`drawercell-${this.selectedDeviceDrawerListByNdc[index].ndc}-${this.selectedDeviceDrawerListByNdc[index].drawerNumber}-${cell}`);
      element.classList.remove('selected-cell');
      
      this.updateTheOtherNdcCellColor(this.selectedDeviceDrawerListByNdc[index].ndc, this.selectedDeviceDrawerListByNdc[index].drawerNumber, cell, false);
    });
   
   
  }

  updateDataSet(row) {
    let index = this.dataSourceGroupCanister.data.findIndex(x => x.ndc === row.ndc);
    this.dataSourceGroupCanister.data[index].groupCanister = row.groupCanister === -1 ? 0 : row.groupCanister;
    this.dataSourceGroupCanister.data[index].highCapGroupCanister = row.highCapGroupCanister === -1 ? 0 : row.highCapGroupCanister;
  }


  selectDrawerCell(drawer: number, ndc: string, cell: number, event) {
    let element = event.target;
    let isAlreadyAddedIndex = this.selectedDeviceDrawerListByNdc.findIndex(x => x.ndc !== ndc && x.drawerCell.includes(cell))
    let isAlreadyAssignThisLocation = this.searchDrawerLocation(drawer, cell); 
    if (isAlreadyAddedIndex === -1 && isAlreadyAssignThisLocation === false) {
      let index = this.selectedDeviceDrawerListByNdc.findIndex(x => x.drawerNumber === drawer && x.ndc === ndc);

      let drawerCellIndex = this.selectedDeviceDrawerListByNdc[index].drawerCell.indexOf(cell)
      if (drawerCellIndex === -1) {

        let isHighCapCanisterCell = this.selectedDeviceDrawerListByNdc.some(x =>
          x.isHighCapCanister && x.ndc == ndc && x.drawerNumber == drawer
        );
        if(isHighCapCanisterCell == false){
        let indexOfDataset = this.dataSourceGroupCanister.data.findIndex(x => x.ndc === ndc);
        if(this.dataSourceGroupCanister.data[indexOfDataset].groupCanister>=8){
          this.toastService.openToast(`Oops! It seems you've reached the maximum limit of canister cells allowed for this NDC. No further selections can be made.`, constants.ToastPanelType.error, 2);
          return;
        }
      } 

        this.selectedDeviceDrawerListByNdc[index]?.drawerCell.push(cell);
        let [groupCanister, highCapGroupCanister] = this.selectedListLengthBasedOnNdc(ndc);
        this.updateSelectedGroupCanisterList({
          ndc: this.selectedDeviceDrawerListByNdc[index].ndc, 
          groupCanister: groupCanister,
          highCapGroupCanister: highCapGroupCanister
        })

        this.updateDataSet({
          ndc: this.selectedDeviceDrawerListByNdc[index].ndc,
          groupCanister: groupCanister,
          highCapGroupCanister: highCapGroupCanister
        });

        element.classList.add('selected-cell');
        this.updateTheOtherNdcCellColor(ndc, drawer, cell, true);
      }
      else {
        this.selectedDeviceDrawerListByNdc[index]?.drawerCell.splice(drawerCellIndex, 1);

        let [groupCanister, highCapGroupCanister] = this.selectedListLengthBasedOnNdc(ndc);

        this.updateSelectedGroupCanisterList({
          ndc: this.selectedDeviceDrawerListByNdc[index].ndc, groupCanister: groupCanister,
          highCapGroupCanister: highCapGroupCanister
        })

        this.updateDataSet({
          ndc: this.selectedDeviceDrawerListByNdc[index].ndc, groupCanister: groupCanister,
          highCapGroupCanister: highCapGroupCanister
        });
        element.classList.remove('selected-cell');
        this.updateTheOtherNdcCellColor(ndc, drawer, cell, false);
      }
    }
    else {
      if(isAlreadyAssignThisLocation === false ){
        this.toastService.openToast(`This drawer cell has already been utilized for this NDC-${this.selectedDeviceDrawerListByNdc[isAlreadyAddedIndex].ndc}`, constants.ToastPanelType.error, 2);
      }
      else{
        this.toastService.openToast(`This drawer cell has already been utilized`, constants.ToastPanelType.error, 2);
      }
      
      element.classList.remove('selected-cell');
    }
  }

  updateTheOtherNdcCellColor(ndc:string, drawerNumber:number, cell:number, isSelect:boolean){
    this.dataSourceGroupCanister.data.forEach(row => {
      if(row.ndc!= ndc){
        
        let element = document.getElementById(`drawercell-${row.ndc}-${drawerNumber}-${cell}`);
        if(isSelect){
        element.classList.add('already-selected-cell');
        }
        else{
          element.classList.remove('already-selected-cell');
        }
      }
    });
    
  }
  searchDrawerLocation(drawerNo: number, location: number): boolean{
    let result = this.assignDrawerCellList.find(
      (drawerLocation) => drawerLocation.drawerNo === drawerNo && drawerLocation.locations.includes(location)
    );
  
    return result == null ? false :  true;
  }

  selectedListLengthBasedOnNdc(ndc: string): [groupCanister: number, highcapGroupCanister: number] {
    let groupCanister = 0, highCapGroupCanister = 0;

    for (let i = 0; i < this.selectedDeviceDrawerListByNdc.length; i++) {
      if (this.selectedDeviceDrawerListByNdc[i].ndc === ndc && this.selectedDeviceDrawerListByNdc[i].isHighCapCanister) {
        highCapGroupCanister += this.selectedDeviceDrawerListByNdc[i].drawerCell.length;
      }
      else if (this.selectedDeviceDrawerListByNdc[i].ndc === ndc && !this.selectedDeviceDrawerListByNdc[i].isHighCapCanister) {
        groupCanister += this.selectedDeviceDrawerListByNdc[i].drawerCell.length;
      }
    }
    return [groupCanister, highCapGroupCanister];
  }


  deviceAllCellGenerate() {
    const numRows = 8;
    const numCols = 2;
    for (let drawer = 1; drawer <= 16; drawer++) {
      this.devceDrawerLevel = `Drawer-${drawer}`
      let counter = 16 * (drawer - 1) + 1;
      this.deviceCell = [];
      for (let i = 0; i < numRows; i++) {
        const row = [];
        for (let j = 0; j < numCols; j++) {
          if (j === 1) {
            row.push(counter + 7);
          }
          else {
            row.push(counter++);
          }
        }
        this.deviceCell.push(row);
      }
      this.deviceDrawer.push({ drawerName: this.devceDrawerLevel, drawerNumber: drawer, drawerCell: this.deviceCell })
    }
  }

  //#endregion



}
